import { Link } from 'react-router-dom';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useChecklistTemplates, useServiceChecklistTemplate } from '@/hooks/useChecklists';

interface ServiceChecklistFieldProps {
  orgId: string | null;
  serviceId: string | null;
  /** undefined = not changed yet (shows the saved value). */
  value: string | null | undefined;
  onChange: (templateId: string | null) => void;
}

const NONE = 'none';

/** "Default checklist" picker on the Services editor. */
export function ServiceChecklistField({ orgId, serviceId, value, onChange }: ServiceChecklistFieldProps) {
  const { data: templates = [] } = useChecklistTemplates(orgId);
  const { data: saved = null } = useServiceChecklistTemplate(serviceId);
  const current = value !== undefined ? value : saved;

  return (
    <div className="col-span-2 space-y-2">
      <Label htmlFor="service-checklist">Default checklist</Label>
      <Select value={current ?? NONE} onValueChange={(v) => onChange(v === NONE ? null : v)}>
        <SelectTrigger id="service-checklist" data-testid="service-checklist-select">
          <SelectValue placeholder="No checklist" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE}>No checklist</SelectItem>
          {templates.map((t) => (
            <SelectItem key={t.id} value={t.id}>
              {t.name} ({t.items.length} {t.items.length === 1 ? 'item' : 'items'})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-[12px] text-muted-foreground">
        New jobs for this service, including repeat cleans, get a copy of this list for your cleaners to tick off.{' '}
        <Link to="/admin/checklists" className="font-medium text-primary underline-offset-2 hover:underline">
          Manage checklists
        </Link>
      </p>
    </div>
  );
}
